import React from 'react'
import { useSearchInput } from 'utils/hooks/useSearchInput'

const useCompanySearchInputs = () => {
  const parentSearch = useSearchInput('', { debounceMs: 400 })
  const childrenSearch = useSearchInput('', { debounceMs: 400 })
  const { setCommittedValue: setChildrenCommittedValue, setDisplayValue: setChildrenDisplayValue } =
    childrenSearch

  const resetChildrenSearch = React.useCallback(() => {
    setChildrenCommittedValue('')
    setChildrenDisplayValue('', { skipCommit: true })
  }, [setChildrenCommittedValue, setChildrenDisplayValue])

  return {
    parentSearch,
    childrenSearch,
    resetChildrenSearch,
  }
}

export { useCompanySearchInputs }
